<template>
    <nav id="sidebar" class="">
        <ul class="list-unstyled sidebar-menu components mb-5">
            <li :class="menu_active == 'home' ? 'active' : ''">
                <router-link :to="{ name: 'home' }" @click.native="getSoundClick">
                    <img src="/themes/ito/images/menu-icon1.png">{{ $t('menu_item_home') }}
                </router-link>
            </li>

            <li class="live-class-menu" :class="{ active: menu_active == 'live_class', disable: lock_features.includes('live_class') }" v-if="user_info.account_live_class == 1">
                <router-link :to="{ name: 'live_class' }" @click.native="getSoundClick">
                    <img src="/themes/ito/images/live-class.svg">{{ $t('live_class') }}
                </router-link>
                <div class="live-class-alert" v-if="living_class && is_ism">
                    <div class="live-class-alert-title">{{ $t('class') }}: {{ living_class.class_name }}</div>
                    <div>{{ $t('subject') }}: {{ living_class.subject }}</div>
                    <div><span class="live-class-dot"></span><span class="live-class-text">{{ $t('live_now') }}</span></div>
                    <div style="margin-top: 8px">
                        <button class="btn btn-join-class" style="padding: 4px 10px; width: 100%;">{{ $t('join_to_class')
                            }}</button>
                    </div>
                </div>
            </li>

            <li :class="{ active: menu_active == 'achievement', disable: lock_features.includes('daily_mission') }">
                <router-link :to="lock_features.includes('mission') ? '' : { name: 'achievement' }" @click.native="getSoundClick">
                    <img src="/themes/ito/images/menu-icon3.png">{{ $t('menu_item_achievements') }}
                </router-link>
                <div class="noti-alert" v-if="user_info.count_achieve_unread > 0"></div>
            </li>
            <li :class="{ active: menu_active == 'inbox', disable: lock_features.includes('inbox') }">
                <router-link :to="lock_features.includes('inbox') ? '' : { name: 'inbox' }" @click.native="getSoundClick">
                    <img src="/themes/ito/images/menu-icon4.png">{{ $t('menu_item_inbox') }}
                </router-link>
                <div class="noti-alert" v-if="user_info.count_mail_unread > 0"></div>
            </li>

            <li :class="{ active: menu_active == 'parent', disable: lock_features.includes('parent') }">
                <router-link :to="lock_features.includes('parent') ? '' : { name: 'parent_report' }" @click.native="getSoundClick">
                    <img src="/themes/ito/images/menu-icon5.png">{{ $t('menu_item_parents') }}
                </router-link>
            </li>
        </ul>

    </nav>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { getMenus } from '../models/menu'
import $ from 'jquery'
import { soundClick } from '../utils/utils'
import { getLiveClass } from '../models/dashboard'

export default {
    name: "SideBar",

    data() {
        const lock_feature = this.$store.state.user_info.lock_feature ? Array.prototype.map.call(this.$store.state.user_info.lock_feature, (x) => x.name) : []
        return {
            menus: [],
            live_classes: [],
            living_class: null,
            is_free_trial: false,
            is_ism: false,
            lock_features: lock_feature
        };
    },

    computed: {
        user_info() {
            return this.$store.state.user_info
        },
        menu_active() {
            return this.$store.state.menu_active
        },
        live_classes_data: function () {
            const live_classes = this.$store.state.live_classes || []
            this.live_classes = live_classes;
            if (live_classes.length > 0) {
                that.live_classes.forEach((item) => {
                    if (item.is_live == 1 && that.living_class != null) {
                        that.living_class = item;
                    }
                });
            }
            return live_classes;
        }
    },

    created() {
        this.fetch();
    },

    updated: function () {
        this.$nextTick(function () {
            //App.init();
        })
    },

    methods: {
        fetch() {

            if (this.user_info.account_type == 1) {
                this.is_free_trial = true
            } else {
                this.is_free_trial = false
            }

            if (this.user_info.student_type == 1) {
                this.is_ism = true
            } else {
                this.is_ism = false
            }
        },



        getSoundClick() {
            soundClick();
        },
    }
}
</script>

<style scoped>
.live-class-menu {
    position: relative;
}

.live-class-alert {
    display: block !important;
    position: absolute;
    top: 0;
    left: 105px;
}

.live-class-alert::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    margin-left: -12px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent #fff transparent transparent;
}
</style>